import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenListController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListController.php
* @route '/api/screen-settings'
*/
const GetScreenListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenListController.url(options),
    method: 'get',
})

GetScreenListController.definition = {
    methods: ["get","head"],
    url: '/api/screen-settings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenListController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListController.php
* @route '/api/screen-settings'
*/
GetScreenListController.url = (options?: RouteQueryOptions) => {
    return GetScreenListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenListController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListController.php
* @route '/api/screen-settings'
*/
GetScreenListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenListController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListController.php
* @route '/api/screen-settings'
*/
GetScreenListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenListController.url(options),
    method: 'head',
})

export default GetScreenListController